import { connect } from 'react-redux';
import YearlyDistributionView from './YearlyDistributionView';
import { currentClientId, isPopulatedSelector } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { updateData } from '../../../AdvWorkflow/AdvWorkflowActions';
import {
  selectDistributionDollarAmount,
  selectDistributionPercentage,
  selectDistributionStrategyType,
  selectIsDecumulationGoalValid,
} from '../../DecumulationWorkflow.selector';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  isPopulated: isPopulatedSelector(state, ownProps),
  distributionStrategyType: selectDistributionStrategyType(state, ownProps),
  distributionPercentage: selectDistributionPercentage(state, ownProps),
  distributionDollarAmount: selectDistributionDollarAmount(state, ownProps),
  doNotSave: !selectIsDecumulationGoalValid(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateData(data, workflowId, clientId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(YearlyDistributionView);
